import {
    useMemo,
} from 'react'

import {
    Navigate,
} from 'react-router-dom'
import {
    SkyNetRouteConfigObject, useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    RelationshipsManagementDomains,
} from 'app/enums/domain.enums'
import useRelationshipsManagementRoutes from 'app/SkyNetRoutes/hooks/useRelationshipsManagementRoutes'
import ActivityRecords from './ActivityRecords'
import Engagement from './Engagement'

const RelationshipsManagement = () => {
    const Routes = useRelationshipsManagementRoutes()
    const routesConfig: SkyNetRouteConfigObject<RelationshipsManagementDomains> = useMemo(() => {
        return {
            [Routes.ActivityRecords.route]: <ActivityRecords />,
            [Routes.Engagements.route]: <Engagement />,
            [CommonRoutes.Slash]: <Navigate
                to={Routes.ActivityRecords.route}
                replace
            />,
        }
    }, [Routes])

    return useSkyNetRoutes({
        routesConfig,
    })
}

export default RelationshipsManagement
